
export interface ProtokollInfo {
  protokollTyp: [{idProtokollTyp?: number, isChecked?: boolean, beschreibung?: string}]
}


export class ProtokollStore {

  public static getDataSet( store: any) : ProtokollInfo {
    return store.getters["protokollstore/getDataSet"];
  
  }

  public static setDataSet( store: any, payload: ProtokollInfo) {
    store.commit("protokollstore/setDataSet" , payload)
  }

}

export const protokollstore = {
  namespaced: true,
  state: {
    protokollInfo: {
      protokollTyp: [],
    }
  },
  mutations: {
    setDataSet(state: any, payload: ProtokollInfo) {
      state.protokollInfo = payload;
    }
  },
  actions: {},
  getters: {
    getDataSet: function(state: any): ProtokollInfo {
      return state.protokollInfo;
    }
  }
};

